import axios from 'axios';

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Request-Headers': '*',
    },
};

export function getPageDetail(page) {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/danceUnion/${page}`,
        method: 'get',
        ...config,
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function postPageDetail(page, data, id) {
    delete data._id;
    return axios({
        url: `https://dance-union-backend.herokuapp.com/danceUnion/${page}?id=${id}`,
        method: 'post',
        ...config,
        data: data
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function postGoogleDriveUrl(file, type) {
    const formData = new FormData();
    formData.append('file', file)
    return axios.post(
        `https://dance-union-backend.herokuapp.com/googleDrive?type=${type}`,
        formData,
        {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
    )
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}


export function getBlogList(type) {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/danceUnion/blog/${type}`,
        method: 'get',
        ...config,
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function postBlog(data, type) {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/danceUnion/blog/${type}?id=61a8f1b7fd76d3ded6cb8462`,
        method: 'post',
        ...config,
        data: data
    })
        .then(function (response) {
            return response.status === 200;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function updateBlog(data, type, id) {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/danceUnion/blog/${type}/${id}?id=61a8f1b7fd76d3ded6cb8462`,
        method: 'put',
        ...config,
        data: data
    })
        .then(function (response) {
            return response.status === 200;
        })
        .catch(function (error) {
            console.log(error);
        });
}


export function deleteBlog(id, type) {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/danceUnion/blog/${type}/${id}?id=61a8f1b7fd76d3ded6cb8462`,
        method: 'delete',
        ...config
    })
        .then(function (response) {
            return response.status === 200;
        })
        .catch(function (error) {
            console.log(error);
        });
}


export function getMemberForCall(type) {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/danceUnion/blog/${type}`,
        method: 'get',
        ...config,
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function getMemberDetail(id) {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/member/${id}`,
        method: 'get',
        ...config,
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}


export function getMemberList() {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/member`,
        method: 'get',
        ...config,
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function getMemberListToFollowUp() {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/member/needFollowUp`,
        method: 'get',
        ...config,
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function postMember(data) {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/member`,
        method: 'post',
        ...config,
        data: data
    })
        .then(function (response) {
            return response.status === 200;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function updateMember(data, id) {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/member/${id}`,
        method: 'put',
        ...config,
        data: data
    })
        .then(function (response) {
            return response.status === 200;
        })
        .catch(function (error) {
            console.log(error);
        });
}


export function deleteMember(id) {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/member/${id}`,
        method: 'delete',
        ...config
    })
        .then(function (response) {
            return response.status === 200;
        })
        .catch(function (error) {
            console.log(error);
        });
}


export function getAppointmentList(userId) {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/appointment?memberId=${userId}`,
        method: 'get',
        ...config,
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function getAllAppointmentList() {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/appointment`,
        method: 'get',
        ...config,
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function getTodayAppointmentList() {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/appointment/today`,
        method: 'get',
        ...config,
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function postAppointment(data, userId) {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/appointment?memberId=${userId}`,
        method: 'post',
        ...config,
        data: data
    })
        .then(function (response) {
            return response.status === 200;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function updateAppointment(data, id) {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/appointment/${id}`,
        method: 'put',
        ...config,
        data: data
    })
        .then(function (response) {
            return response.status === 200;
        })
        .catch(function (error) {
            console.log(error);
        });
}


export function deleteAppointment(id) {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/appointment/${id}`,
        method: 'delete',
        ...config
    })
        .then(function (response) {
            return response.status === 200;
        })
        .catch(function (error) {
            console.log(error);
        });
}


// Google Analytics

export function getGAPage() {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/googleAnalytics/page`,
        method: 'get',
        ...config
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function getGABlog() {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/googleAnalytics/blog`,
        method: 'get',
        ...config
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function getGAVideo() {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/googleAnalytics/video`,
        method: 'get',
        ...config
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function getGASource() {
    return axios({
        url: `https://dance-union-backend.herokuapp.com/googleAnalytics/source`,
        method: 'get',
        ...config
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}




